import { Row, Card, Col, Form } from "react-bootstrap";
import { http } from "Utils/http";
import { useEffect, useReducer, useState, useRef } from "react";
import Stack from 'react-bootstrap/Stack';
import { useLocation, useNavigate } from 'react-router-dom';
import 'react-phone-input-2/lib/style.css'
import { TextButton } from 'Components/Button';
import { ERROR_MESSAGES, ORG_TYPES, USER_ROLES, STATUSES } from "Utils/constants";
import { useDispatch } from "react-redux"
import { setGlobalSuccessStatus, setGlobalErrorStatus } from 'Components/StatusHandling';
import 'react-phone-input-2';
import { GetUserTextInputData, GetOrgTextInputData, GetUserCheckboxInputData, GetUserPhoneInputData, GetUserSelectInputData, GetResetPasswordInputData } from 'Containers/Private/User/UserBeanFields';
import { RoleDataReducer } from "Containers/Private/User/RoleDataReducer";
import { getPrefixAndSuffixList, getRegionList } from 'Utils/utilityFunctions';
import { FormInputDisplay } from 'Components/Forms/FormInputDisplay.js';
import InfoTable from "Components/InfoTable/InfoTable";
//import { redirectDocument } from "react-router-dom";
import { store } from 'Store';
import { resetPassword } from "../UserAxiosFuncs";
import DynamicFormPopup from "Components/Popup/DynamicFormPopup";

function ViewDocument () {

    let location = useLocation();
    
    const navigate = useNavigate();
    var passedData = location.state;
    const [showDeletePopup, setShowDeletePopup] = useState(false);

    //console.log(passedData);
    const dispatch = useDispatch();

    const [backRedirect, setBackRedirect] = useState(passedData.backRedirect);
    //const [groupId, setGroupId] = useState(passedData.groupId ? passedData.groupId : 0);
    const [docId, setDocId] = useState(passedData.docId ? passedData.docId : 0);
    const [docData, setDocData] = useState(null);
    const [roleData, setRoleData] = useState(null);

    const [isLoading, setIsLoading] = useState(true);
    
    //const [pageType, setPageType] = useState(null);

    
    const getData = async (docId) => {
        var url = "/api/dlms/viewDocument";
        const loginState = store.getState().loginInfo;

        return http.post(url, {"docId": docId}, {
            headers: {
                "Authorization": "Bearer " + loginState.token
                //"Referrer-Policy": "strict-origin-when-cross-origin"
            }
        });
    }

    const loadData = (docId) => {
        setIsLoading(true);
        getData(docId).then((res) => {
            //console.log("getFormData ", res);
            if (res.status != 1) {
                setGlobalErrorStatus({
                    dispatch: dispatch,
                    popupData: {
                        visible: true,
                        title: ERROR_MESSAGES.DATA_ERROR.title,
                        msg: res.globalErrorMessageList[0],
                        showContactHelp: true
                    },
                    redirect: {
                        redirect: false,
                        redirectFirst: false,
                        path: "",
                        data: {}
                    }
                });
            }
            else {
                var d = res.data;

                //console.log(d);

                setDocData(d.documentDetailBean)
                //console.log(docData);

                setRoleData(d.allRoles);
                
                /*if (d.allRoles != null) {
                    var o = d.allRoles.map((option) => {
                        var role = {
                            id: option.roleName,
                            label: option.description,
                            title: null,
                            name: option.roleName,
                            value: option.roleId,
                            isChecked: d.documentDetailBean.roles.includes(option.roleId + "") ? true : false,
                            //onChange: handleCheckChange,
                            disabled: option.isEnabled == 1 ? false : true
                        }
                        //console.log(option.roleId);
                        //console.log(d.documentDetailBean.roles);
                        //console.log(d.documentDetailBean.roles.includes(option.roleId+""));
                        //console.log(role);
                        return role;
                    });
                    //console.log(o);
                    docRoleIdsInputDispatch({
                        type: ACTIONS.CHECK_UPDATE_CHOICES,
                        options: o
                    })
                }*/

                return d;

            }


        }).catch((error) => {
            //console.log("Error caught while loading data: " + error);

            setGlobalErrorStatus({
                dispatch: dispatch,
                popupData: {
                    visible: true,
                    title: ERROR_MESSAGES.DATA_ERROR.title,
                    msg: ERROR_MESSAGES.DATA_ERROR.message,
                    showContactHelp: true
                },
                redirect: {
                    redirect: false,
                    redirectFirst: false,
                    path: "",
                    data: {}
                },
                error: error
            });
        });
        setIsLoading(false);
    };
    

    useEffect(() => {
        //console.log(backRedirect);
        loadData(docId);
    }, []);

    const displayFileSizeKB = (value, isRounded) => {
        //console.log(value);
        if(value <=0){
            return "0 KB";
        }
        //console.log(1176339/1024);
        var val = value/1024;
        
        if(isRounded==true){
            val = Math.round(val);
        }
        
        var format = new Intl.NumberFormat().format(val);
        return format + " KB";
    };

    const handleDateFormat = (time) => {
        let date = new Date(time);
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        let hour = date.getHours();
        let min = date.getMinutes();
        let sec = date.getSeconds();
        let milli = date.getMilliseconds();
        return (
            (year )  + "-" +
            (month < 10 ? "0" + month : month) + "-" +
            (day < 10 ? "0" + day : day) + " " +
            
            (hour < 10 ? "0" + hour : hour) + ":" +
            (min < 10 ? "0" + min : min) + ":" +
            (sec < 10 ? "0" + sec : sec) + "." +
            (milli)
        )
      }

    const infoTableData = function () {
        var data = [];

        //console.log(docData);

        data.push({
            name: "Document ID",
            value: docId
        });
        data.push({
            name: "Category",
            value: docData.catName
        });
        data.push({
            name: "Owner",
            value: docData.ownerName
        });
        data.push({
            name: "Document Name",
            value: docData.docName
        });
        data.push({
            name: "Display Name",
            value: docData.displayName
        });
        data.push({
            name: "Short Name",
            value: docData.shortName
        });
        data.push({
            name: "Group ID",
            value: docData.groupId
        });
        data.push({
            name: "Version",
            value: docData.version
        });
        data.push({
            name: "Display Order",
            value: docData.displayOrder
        });
        data.push({
            name: "Description",
            value: docData.docDescr
        });
        data.push({
            name: "Published Date",
            value: docData.docPubDate
        });
        data.push({
            name: "Document Size",
            value: displayFileSizeKB(docData.docSize, true)
        });
        data.push({
            name: "Document Disabled",
            value: docData.isDisabled
        });
        data.push({
            name: "Allow Public Access",
            value: docData.allowPubAccess
        });
        data.push({
            name: "Open For Comment",
            value: docData.isOpenForComment
        });
        data.push({
            name: "Assigned Access Role",
            value: ()=> { 
                return (
                    
                    /*<Form.Group as={Col} className="col-auto" >*/
                        <fieldset className="d-flex flex-wrap column-gap-2 row-gap-1 align-items-center flex-fit">
                            
                            <legend hidden={true} className="flex-lg-shrink-0 form-label">
                                {<span className="me-2 ">Roles</span>}
                            </legend>
                            {
                                roleData.map((r,index) => 
                                    
                                    <Form.Check
                                        //key={"chkDropdown" + (idKey==null ? index : v[idKey])}
                                        type="checkbox"
                                        //title={v.title}
                                        label={ 
                                            r.roleName
                                        }
                                        name={"roleId" + r.roleId}//"chkDropdown" + (idKey==null ? index : v[idKey])}
                                        id={"roleId" + r.roleId}//"chkDropdown" + (idKey==null ? index : v[idKey]) + unique}
                                        value={r.roleId}//idKey==null ? v : v[idKey]}
                                        className={"ms-0 me-2 mb-0 w-auto"}
                                        checked={docData.roles.includes((r.roleId+""))? true : false}
                                        disabled={true}
                                    ></Form.Check>
                                
                                )
                            }
                        </fieldset>
                   // </Form.Group>
                );
            }
        });
        data.push({
            name: "Download Count",
            value: docData.downLoadCount
        });
        data.push({
            name: "Added By/On",
            value: docData.addedByUser + "/ " + handleDateFormat(docData.addedOn)
        });
        data.push({
            name: "Updated By/On",
            value: docData.updatedByUser + "/ " + handleDateFormat(docData.updatedOn)
        });

        return data;
    }

    const handleBack = async () => {
        if (backRedirect.path == null) {
            setBackRedirect("/manage/document");
        }
        //localStorage.setItem('state', JSON.stringify(backRedirect.state));
        navigate(
            backRedirect.path,
            { state: backRedirect.state }
        );
        //clearErrorMessages(formInfo.data);
    };

    const handleDelete = async () => {
        hidePopup();
        var url = '/api/dlms/deleteDocument';
        const loginState = store.getState().loginInfo;
        const res = http.post(url,  {"docId": docId}, {
            headers: {
                "Authorization": "Bearer " + loginState.token
            }
        }).then((response) => {
            if (response != null) {
                //console.log(response);
                var statusCode = response.status;
                if (statusCode != 1) {

                    if (response.globalErrorMessageList && response.globalErrorMessageList.length > 0) {
                        setGlobalErrorStatus({
                            dispatch: dispatch,
                            popupData: {
                                visible: true,
                                title: ERROR_MESSAGES.GENERAL_ERROR.title,
                                msg: response.globalErrorMessageList,
                                showContactHelp: false
                            },
                            redirect: {
                                redirect: false,
                                redirectFirst: false,
                                path: "",
                                data: {}
                            }
                        });
                    }
                }
                else {
                    if (backRedirect.path == null) {
                        setBackRedirect("/manage/document");
                    }
                    setGlobalSuccessStatus({
                        dispatch: dispatch,
                        popupData: {
                            visible: true,
                            title: "Success!",
                            //msg: "Document has been sucessfully deleted.",
                            msg: response.message,
                            showContactHelp: false
                        },
                        redirect: {
                            redirect: true,
                            redirectFirst: true,
                            path: backRedirect.path,
                            data: { state: backRedirect.state }
                        }
                    });
                }
            }
            else {
                setGlobalErrorStatus({
                    dispatch: dispatch,
                    popupData: {
                        visible: true,
                        title: ERROR_MESSAGES.GENERAL_ERROR.title,
                        msg: ERROR_MESSAGES.GENERAL_ERROR.message,
                        showContactHelp: true
                    },
                    redirect: {
                        redirect: false,
                        redirectFirst: false,
                        path: "",
                        data: {}
                    }
                });
            }
        }).catch(function (error) {
            setGlobalErrorStatus({
                dispatch: dispatch,
                popupData: {
                    visible: true,
                    title: ERROR_MESSAGES.GENERAL_ERROR.title,
                    msg: ERROR_MESSAGES.GENERAL_ERROR.message,
                    showContactHelp: true
                },
                redirect: {
                    redirect: false,
                    redirectFirst: false,
                    path: "",
                    data: {}
                },
                error: error
            });
        });
        return res;
    };

    const hidePopup = () => {
        setShowDeletePopup(false);
    }
    const showPopup = () => {
        setShowDeletePopup(true);
    }

    var popupButtons = [
        {
            text: "Yes",
            action: handleDelete,
            variant: "normal",
            //disabled: feedbackCharCount < 1 || isFeedbackLoading==true ? true: false
        },
        {
            text: "No",
            action: hidePopup,
            variant: "outline",
            //disabled: false
        }
    ]

    
    const colSizes = {
        label: {
            xl: 3,
            lg: 4,
            md: 4,
            sm: 4,
            xs: 5
        },
        value: {
            xl:9,
            lg:8,
            md:8,
            sm:8,
            xs:7
        }
        
    }
        

    return (
        <Row >
            {isLoading == true || docData == null
                ? null
                :
                <Row >
                    <Col xl={11} lg={11} md={11} sm={12}>
                        <Card className="p-4" >
                            <Card.Body className="text-start">

                                <Row>
                                    <h1 id="mainContent" className="header1 text-start mb-3 blue bold">View Document Detail</h1>
                                </Row>
                                <Row>
                                    <Form>
                                        <Col
                                            md={12}
                                            lg={12}
                                            xl={12}

                                        >
                                            <InfoTable data={infoTableData()} colSizes={colSizes}></InfoTable>
                                            
                                        </Col>
                                        

                                        <Stack className="mt-3"  direction="horizontal" gap={3}>
                                            {/* Delete Button */}
                                                <TextButton
                                                    variant="normal"
                                                    onClick={showPopup}
                                                    content={"Delete"}
                                                >
                                                </TextButton>
                                                {/* Back Button */}
                                                <TextButton
                                                    variant="outline"
                                                    onClick={handleBack}
                                                    content={"Back"}
                                                    className=""
                                                >
                                                </TextButton>
                                        </Stack>
                                    </Form>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                    <DynamicFormPopup
                        showPopup = {showDeletePopup}
                        handleClose = {hidePopup}
                        buttons = {popupButtons}
                        title = {"Delete Confirmation"}
                        type= {"blank"}
                        variant={"warning"}
                    >
                        
                        Are you sure you want to delete this document?
                    </DynamicFormPopup>
                </Row>
                
            }
        </Row>
    );
}


export default ViewDocument;
